/**
 * Enlace del odontograma con las especialidades: trae los hallazgos del paciente y ofrece, al abrir una
 * endodoncia o planificar implantes, las piezas que el odontograma ya marca para ese tratamiento.
 */
import { useEffect, useState } from "react";
import { api, type Odontograma } from "../api.ts";
import { nombrePieza, piezasSugeridas, type PiezaSugerida } from "../../../dominio/src/index.ts";

/** Piezas sugeridas por el odontograma (vacío mientras carga o si no hay nada marcado). */
export function useSugeridas(pacienteId: string, para: "endodoncia" | "implante", excluir: readonly number[] = []): PiezaSugerida[] {
  const [lista, setLista] = useState<PiezaSugerida[]>([]);
  useEffect(() => {
    let vivo = true;
    api<Odontograma>("GET", `/api/pacientes/${pacienteId}/odontograma`)
      .then((o) => { if (vivo) setLista(piezasSugeridas(o.hallazgos, para)); })
      .catch(() => { if (vivo) setLista([]); });
    return () => { vivo = false; };
  }, [pacienteId, para]);
  return lista.filter((x) => !excluir.includes(x.pieza));
}

/** Campo de pieza (FDI) con las piezas del odontograma para elegir con un toque. */
export function CampoPieza({ valor, sugeridas, etiqueta, alCambiar, ancho }: {
  valor: number; sugeridas: PiezaSugerida[]; etiqueta: string; alCambiar: (n: number) => void; ancho?: boolean;
}) {
  return (
    <div className={`campo-pieza${ancho ? " ancho" : ""}`}>
      <label className="campo corto">Pieza<input className="mono" inputMode="numeric" value={valor || ""}
        onChange={(e) => alCambiar(Number(e.target.value.replace(/\D/g, "").slice(0, 2)))} aria-label={etiqueta} /></label>
      {sugeridas.length > 0 && (
        <div className="piezas-sugeridas" role="group" aria-label="Piezas marcadas en el odontograma">
          <span className="muted">Del odontograma:</span>
          {sugeridas.map((s) => (
            <button key={s.pieza} type="button" className="chip-pieza" aria-pressed={valor === s.pieza} title={`${nombrePieza(s.pieza)} · ${s.motivo}`}
              onClick={() => alCambiar(s.pieza)}>
              <b className="mono">{s.pieza}</b> {s.motivo}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
